<template>
  <DxPopup
    :width="560"
    :height="220"
    :show-title="true"
    :drag-enabled="false"
    opened-state-mode="shrink"
    :visible="true"
    :wrapper-attr="popupAttributes"
    :title="warningModalTitle"
  >
    <div class="popup-property-details">
      <div class="large-text modal-text">{{ modalText }}</div>
      <div class="buttons" style="display: flex; justify-content: space-evenly">
        <DxButton
          class="orange-btn-filled"
          :text="t('common.yes')"
          @click="onOkFunction()"
          :hint="warningModalToolTipTextYes"
        />
        <DxButton
          class="orange-btn bg-gray-button"
          :text="t('common.no')"
          @click="closeModal()"
          :hint="warningModalToolTipTextNo"
        />
      </div>
    </div>
  </DxPopup>
</template>
<script>
import { computed, ref } from "vue";
import { DxPopup } from "devextreme-vue/popup";
import { DxButton } from "devextreme-vue/button";
import store from "../../store";

export default {
  props: {
    onOk: Function,
  },
  components: {
    DxButton,
    DxPopup,
  },
  setup(props) {
    const onOkFunction = ref(props.onOk);

    const warningModalToolTipTextYes = computed(
      () => store.state.warningModal.warningModalToolTipTextYes
    );
    const warningModalToolTipTextNo = computed(
      () => store.state.warningModal.warningModalToolTipTextNo
    );
    const warningModalTitle = computed(
      () => store.state.warningModal.warningModalTitle
    );
    const modalText = computed(() => store.state.warningModal.warningModalText);

    const popupAttributes = ref({
      class: "warning-popup",
    });

    const closeModal = () => {
      store.commit("warningModal/closeWarningModal");
    };

    return {
      onOkFunction,
      warningModalToolTipTextYes,
      warningModalToolTipTextNo,
      warningModalTitle,
      modalText,
      popupAttributes,
      closeModal,
    };
  },
};
</script>
<style lang="scss">
.warning-popup {
  .popup-content {
    display: flex;
    justify-content: space-around;
    margin-top: 5px;
    flex-direction: column;
    width: 100%;
    min-width: 250px !important;
  }
  .dx-overlay-content {
    background-color: #f1f1f1 !important;
  }
  .dx-popup-title {
    border-bottom: 1px solid #ff8500 !important;
  }
}
.buttons {
  min-width: 300px !important;
  margin-top: 1rem;
}
.large-text {
  font-size: 14px !important;
  display: flex !important;
  justify-content: center !important;
}
.modal-text {
  margin: 0.5rem;
}
</style>
